import { render, staticRenderFns } from "./PrettyWaypoint.vue?vue&type=template&id=26547002"
import script from "./PrettyWaypoint.vue?vue&type=script&lang=js"
export * from "./PrettyWaypoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports